import {
  FETH_CONTACT_INFO_BEGIN,
  FETH_CONTACT_INFO_SUCCESS,
  FETH_CONTACT_INFO_FAILED,
} from "actions/contactActions";

const initialState = {
  contactUsHtml: null,
  fetching: false,
  fetched: false,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETH_CONTACT_INFO_BEGIN:
      return { ...state, fetching: true };
    case FETH_CONTACT_INFO_FAILED:
      return { ...state, fetching: false, error: action.payload };
    case FETH_CONTACT_INFO_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        contactUsHtml: action.payload.contactUsHtml,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/contactReducer.jsx